import { useEffect, useState } from "react";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialButton from "../../../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import MaterialSelect from "../../../components/MaterialSelect";
import MaterialInput from "../../../components/MaterialInput";
import axios from "axios";
import { BASE_URL, deleteData, fetchDataById } from "../../Utils/Baseurl";
import { useSnackbar } from "../../../components/SnackbarProvider";
import SimpleTable from "../../../components/SimpleTable";
import { useLoading } from "../../../context/loadingcontext";
import Swal from "sweetalert2";
import MaterialDatePicker from "../../../components/MaterialDatePicker";
import { getProjectsMiddleware } from "../../../api/projectMiddleware";



const MileStone = () => {
  const { showSnackbar } = useSnackbar();
  const { setCirleLoading } = useLoading();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [mileStoneData, setMileStoneData] = useState({
    project: "",
    mileStoneName: "",
    mileStoneDescription: "",
    startDate: "",
    endDate: "",
    projectStatus: "unchecked",
    mileStoneNameStatus: "unchecked",
    mileStoneDescriptionStatus: "unchecked",
    startDateStatus: "unchecked",
    endDateStatus: "unchecked",
  });

  const [pages, setPages] = useState({
    view: false,
    edit: false,
    id: "",
  });
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [projectData, setProjectData] = useState([]);
  const [mileStoneList, setMileStoneList] = useState([]);
  const [editID, setEditID] = useState(0);
  const currentUser = sessionStorage.getItem("currentUser");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);


  useEffect(() => {
    fetchProjectData();
    fetchMileStone();
  }, []);

  /**
   * Fetches a list of projects from the API and updates the state with the retrieved data.
   * Retrieves the authentication token from session storage and includes it in the request headers.
   * Upon successful response, sets the projectData state with the fetched data.
   * Logs any errors encountered during the fetch operation.
   */
  const fetchProjectData = async () => {
    try {
      const userId = sessionStorage.getItem("currentUser");
      const response = await getProjectsMiddleware(userId)
      setProjectData(response.data);
    } catch (error) {
      console.log(error, "error");
    }
  };

  /**
   * Fetches a list of milestones from the API and updates the state with the retrieved data.
   * Retrieves the authentication token from session storage and includes it in the request headers.
   * Upon successful response, sets the mileStoneList state with the fetched data.
   * Logs any errors encountered during the fetch operation.
   */
  const fetchMileStone = async () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.post(
        `${BASE_URL}api/usermilestone/`,
        {
          user_id: currentUser,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setMileStoneList(response.data.data);
    } catch (error) {
      console.log(error, "error");
    }
  };

  /**
   * Handles changes to the project select input field.
   * Updates the `project` and `projectStatus` fields in the `mileStoneData` state.
   * If the selected project is not empty, sets the `projectStatus` to "success", otherwise sets it to "error".
   * @param {Object} selectedOption The selected project option, containing the project ID and name.
   */
  const handleProjectChange = (selectedOption) => {
    console.log(selectedOption, 'selectedOption')
    setMileStoneData((prevData) => ({
      ...prevData,
      project: selectedOption,
      projectStatus: selectedOption ? "success" : "error",
    }));
    setSelectedDate(selectedOption?.startDate || null);
    setSelectedEndDate(selectedOption?.endDate || null);
  };

  /**
   * Handles changes to milestone input fields and updates the milestone data state.
   * Validates the input values and updates the corresponding status fields to either "success" or "error".
   * Supported fields include milestone name, description, start date, and end date.
   *
   * - For `mileStoneName` and `mileStoneDescription`, ensures the value is alphanumeric and non-empty.
   * - For `startDate`, ensures the date is in the correct format (`YYYY-MM-DD`) and not in the past.
   * - For `endDate`, ensures the date is in the correct format and is not before the start date.
   *
   * @param {Object} e - The event object containing the name and value of the changed input field.
   */

  const handleMileStoneChange = (e) => {
    const { name, value } = e.target;

    setMileStoneData((prevData) => {
      const updatedData = { ...prevData };
      const statusField = `${name}Status`;

      switch (name) {
        case "mileStoneName":
          const nameRegex = /^[a-zA-Z0-9\s]*$/;
          if (value.trim() === "" || !nameRegex.test(value)) {
            updatedData[statusField] = "error";
          } else {
            updatedData[statusField] = "success";
          }
          updatedData[name] = value;
          break;

        case "mileStoneDescription":
          const descRegex = /^[\w\s!@#$%^&*()\-_=+[\]{};:'",.<>/?|\\`~]*$/;
          if (value.trim() === "" || !descRegex.test(value)) {
            updatedData[statusField] = "error";
          } else {
            updatedData[statusField] = "success";
          }
          updatedData[name] = value;
          break;

        case "startDate":
          const startValid = /^\d{4}-\d{2}-\d{2}$/.test(value);
          if (!startValid) {
            updatedData[statusField] = "error";
          } else {
            const startDate = new Date(value);
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            updatedData[statusField] = "success";
          }
          updatedData[name] = value;
          break;

        case "endDate":
          const endValid = /^\d{4}-\d{2}-\d{2}$/.test(value);
          if (!endValid) {
            updatedData[statusField] = "error";
          } else {
            const endDate = new Date(value);
            const startDate = new Date(prevData.startDate);

            if (endDate < startDate) {
              updatedData[statusField] = "error";
            } else {
              updatedData[statusField] = "success";
            }
          }
          updatedData[name] = value;
          break;

        default:
          break;
      }

      return updatedData;
    });
  };

  const handleDialogOpen = () => {
    setDialogOpen(true);
    setPages({
      view: false,
      edit: false,
      id: "",
    });
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setMileStoneData({
      project: "",
      mileStoneName: "",
      mileStoneDescription: "",
      startDate: "",
      endDate: "",
      projectStatus: "unchecked",
      mileStoneNameStatus: "unchecked",
      mileStoneDescriptionStatus: "unchecked",
      startDateStatus: "unchecked",
      endDateStatus: "unchecked",
    });
  };

  /**
   * Submits a new milestone to the API.
   *
   * Collects milestone data from the state, constructs a FormData object, and sends a POST request to the API.
   * If successful, closes the dialog, resets the milestone data state, shows a success snackbar, and refetches the milestones.
   * If the request fails, logs the error and shows an error snackbar.
   *
   * Requires authentication; retrieves the token from session storage and includes it in the request headers.
   */

  const handleSubmitMileStone = async () => {
    const { project, mileStoneName, mileStoneDescription, startDate, endDate } =
      mileStoneData;

    try {
      const data = {
        project: project.value,
        milestone_name: mileStoneName,
        milestone_describtion: mileStoneDescription,
        start_date: startDate,
        end_date: endDate,
        user_id: currentUser,
      };

      const token = sessionStorage.getItem("token");
      const response = await axios.post(`${BASE_URL}api/milestone/`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      showSnackbar("Milestone added successfully", "success");
      setDialogOpen(false);
      setMileStoneData({
        project: "",
        mileStoneName: "",
        mileStoneDescription: "",
        startDate: "",
        endDate: "",
        projectStatus: "unchecked",
        mileStoneNameStatus: "unchecked",
        mileStoneDescriptionStatus: "unchecked",
        startDateStatus: "unchecked",
        endDateStatus: "unchecked",
      });
      fetchMileStone();
    } catch (error) {
      console.error("Submit error:", error);
      showSnackbar("Failed to add the milestone", "error");
    }
  };

  const handleUpdateMileStone = async () => {
    const { project, mileStoneName, mileStoneDescription, startDate, endDate } =
      mileStoneData;

    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.put(
        `${BASE_URL}api/milestone/${editID}/`,
        {
          project: project.value,
          milestone_name: mileStoneName,
          milestone_describtion: mileStoneDescription,
          start_date: startDate,
          end_date: endDate,
          user_id: currentUser,
          id: mileStoneData.id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      showSnackbar("Milestone updated successfully", "success");
      setDialogOpen(false);
      setMileStoneData({
        project: "",
        mileStoneName: "",
        mileStoneDescription: "",
        startDate: "",
        endDate: "",
        projectStatus: "unchecked",
        mileStoneNameStatus: "unchecked",
        mileStoneDescriptionStatus: "unchecked",
        startDateStatus: "unchecked",
        endDateStatus: "unchecked",
      });
      fetchMileStone();
    } catch (error) {
      console.error("Update error:", error);
      showSnackbar("Failed to update the milestone", "error");
      setDialogOpen(false);
      setMileStoneData({
        project: "",
        mileStoneName: "",
        mileStoneDescription: "",
        startDate: "",
        endDate: "",
        projectStatus: "unchecked",
        mileStoneNameStatus: "unchecked",
        mileStoneDescriptionStatus: "unchecked",
        startDateStatus: "unchecked",
        endDateStatus: "unchecked",
      });
    } finally {
      setDialogOpen(false);
    }
  };

  const mileStoneTable = {
    columns: [
      {
        key: "projectName",
        header: "Project Name",
      },
      {
        key: "milestoneName",
        header: "Milestone Name",
      },
      {
        key: "startDate",
        header: "Start Date",
      },
      {
        key: "endDate",
        header: "End Date",
      },
      {
        key: "actualStartDate",
        header: "Actual Start Date",
      },
      {
        key: "actualEndDate",
        header: "Actual End Date",
      },
      { header: "ACTION", key: "action" },
    ],
    row: mileStoneList?.map((item) => ({
      id: item?.id ?? "-",
      projectName: item?.project_name
        ? item.project_name.replace(/_/g, " ")
        : "-",
      milestoneName: item?.milestone_name
        ? item.milestone_name.replace(/_/g, " ")
        : "-",
      startDate: item?.start_date ? item.start_date.replace(/_/g, " ") : "-",
      endDate: item?.end_date ? item.end_date.replace(/_/g, " ") : "-",
      actualStartDate: item?.actual_start_date
        ? item.actual_start_date.replace(/_/g, " ")
        : "-",
      actualEndDate: item?.actual_end_date
        ? item.actual_end_date.replace(/_/g, " ")
        : "-",
    })),
  };

  /**
   * Fetches a specific milestone's data from the API and updates the state with the retrieved data.
   * Retrieves the authentication token from session storage and includes it in the request headers.
   * Upon successful response, sets the mileStoneData state with the fetched data.
   * Logs any errors encountered during the fetch operation.
   * @param {number} row - id of the milestone to be edited
   * @returns {Promise<void>}
   */
  const editMileStone = async (row) => {
    handleDialogOpen();
    setCirleLoading(true);
    setPages({
      view: false,
      edit: true,
      id: row,
    });
    try {
      const response = await fetchDataById(`api/milestone/${row}/`);

      setEditID(response.data.id);
      if (response.status) {
        setMileStoneData((prev) => ({
          ...prev,
          project: {
            value: response?.data?.project,
            label: response?.data?.project_name,
          },
          mileStoneName: response?.data?.milestone_name,
          mileStoneDescription: response?.data?.milestone_describtion,
          startDate: response?.data?.start_date,
          endDate: response?.data?.end_date,
          projectStatus: "success",
          mileStoneNameStatus: "success",
          mileStoneDescriptionStatus: "success",
          startDateStatus: "success",
          endDateStatus: "success",
        }));
      }
      fetchMileStone();
    } catch (error) {
      console.error("Error fetching team data:", error);
      showSnackbar("Failed to edit the milestone", "error");
    } finally {
      setCirleLoading(false);
    }
  };

  /**
   * Fetches a specific milestone's data from the API and updates the state with the retrieved data.
   * Retrieves the authentication token from session storage and includes it in the request headers.
   * Upon successful response, sets the mileStoneData state with the fetched data.
   * Logs any errors encountered during the fetch operation.
   * @param {number} row - id of the milestone to be viewed
   * @returns {Promise<void>}
   */
  const mileStoneView = async (row) => {
    handleDialogOpen();
    setCirleLoading(true);
    setPages({
      view: true,
      edit: false,
      id: row,
    });
    try {
      const response = await fetchDataById(`api/milestone/${row}/`);
      if (response.status) {
        setMileStoneData((prev) => ({
          ...prev,
          project: {
            value: response?.data?.project,
            label: response?.data?.project_name,
          },
          mileStoneName: response?.data?.milestone_name,
          mileStoneDescription: response?.data?.milestone_describtion,
          startDate: response?.data?.start_date,
          endDate: response?.data?.end_date,
          projectStatus: "success",
          mileStoneNameStatus: "success",
          mileStoneDescriptionStatus: "success",
          startDateStatus: "success",
          endDateStatus: "success",
        }));
      }
    } catch (error) {
      console.error("Error fetching team data:", error);
      showSnackbar("Failed to edit the milestone", "error");
    } finally {
      setCirleLoading(false);
    }
  };

  const handleMileStoneDelete = (id) => {
    // setSelectedRow(row);
    fetchDelteMileStone(id);
    // setOpen(true);
  };

  const handleStartDateChange = (data) => {
    if (!data || !data[0]) return;

    const date = new Date(data[0]);


    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;

    console.log(formattedDate, "formatted date");

    setMileStoneData((prevData) => ({
      ...prevData,
      startDate: formattedDate,
      startDateStatus: "success",
    }));
  };


  const handleEndDateChange = (data) => {
    if (!data || !data[0]) return;

    const date = new Date(data[0]);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;

    console.log(formattedDate, "formatted date");

    setMileStoneData((prevData) => ({
      ...prevData,
      endDate: formattedDate,
      endDateStatus: "success",
    }));
  };


  const fetchDelteMileStone = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure you want to delete this task creation?",
      text: "This action is irreversible and cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      cancelButtonText: "Cancel",
    });
    if (result.isConfirmed) {
      setCirleLoading(true);
      try {
        const response = await deleteData(`api/milestone/${id}/`);
        if (response.status) {
          showSnackbar(response?.message, "success");
        } else {
          showSnackbar(response?.message, "error");
        }
        fetchMileStone();
      } catch (error) {
        let message = "An unexpected error occurred";
        if (error?.response?.data?.message) {
          message = error.response.data.message;
          // fetchSprintList();
          fetchMileStone();
        } else if (error?.message) {
          message = error.message;
        }

        showSnackbar(message, "error");
      } finally {
        setCirleLoading(false);
      }
    }
  };

  const handleCancel = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  /**
   * Deletes a milestone based on the selected row id, and then re-fetches the milestone list.
   * Retrieves the authentication token from session storage and includes it in the request headers.
   * Upon successful response, shows a success snackbar with the message 'Milestone deleted successfully'.
   * Upon error, logs the error and shows an error snackbar with the message 'Failed to delete the milestone'.
   * @function
   */
  const handleConfirmDelete = () => {
    try {
      const token = sessionStorage.getItem("token");
      const response = axios.delete(
        `${BASE_URL}api/milestone/${selectedRow}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      showSnackbar("Milestone deleted successfully", "success");
      fetchMileStone();
    } catch (error) {
      console.log(error);
      showSnackbar("Failed to delete the milestone", "error");
    } finally {
      setCirleLoading(false);
    }
    setOpen(false);
    setSelectedRow(null);
    fetchMileStone();
    window.location.reload();
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      mileStoneData.projectStatus === "success" &&
      mileStoneData.mileStoneNameStatus === "success" &&
      mileStoneData.mileStoneDescriptionStatus === "success" &&
      mileStoneData.startDateStatus === "success" &&
      mileStoneData.endDateStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const parseDate = (dateStr) => {
    if (!dateStr) return null;
    const parts = dateStr.split("-");
    return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`); // YYYY-MM-DD
  };

  return (
    <DashboardLayout>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        p={1}
        mb={2}
      >
        <Stack direction="column" spacing={0}>
          <MaterialTypography variant="h5" fontWeight="bold" color="dark">
            Milestone
          </MaterialTypography>
          <MaterialTypography variant="caption" color="text">
            You can view the milestone list here.
          </MaterialTypography>
        </Stack>

        <MaterialButton
          variant="gradient"
          color="dark"
          size="small"
          startIcon={<AddIcon />}
          onClick={handleDialogOpen}
        >
          Add milestone
        </MaterialButton>
      </Stack>

      <SimpleTable
        columns={mileStoneTable?.columns}
        data={mileStoneTable?.row}
        onEdit={editMileStone}
        onDelete={handleMileStoneDelete}
        onView={mileStoneView}
      />

      <Dialog
        open={dialogOpen}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleDialogClose();
          }
        }}
        aria-labelledby="new-employee-dialog-title"
        sx={{ "& .MuiDialog-paper": { width: "600px", maxWidth: "90%" } }}
      >
        <DialogTitle id="new-employee-dialog-title">
          {pages?.view
            ? "View MileStone"
            : pages?.edit
              ? "Edit MileStone"
              : "Add MileStone"}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Stack direction="column" spacing={1}>
                <MaterialTypography variant="caption" color="text">
                  Project Name<span style={{ color: "red" }}>*</span>
                </MaterialTypography>
                <MaterialSelect
                  label="Project Name"
                  name="project"
                  value={mileStoneData.project}
                  onChange={handleProjectChange}
                  options={projectData.map((item) => ({
                    value: item.project_id,
                    label: item.project_name,
                    startDate: item.start_date,
                    endDate: item.end_date,
                  }))}
                  error={mileStoneData.projectStatus === "error"}
                  success={mileStoneData.projectStatus === "success"}
                  isDisabled={pages.view === true}
                />
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Stack direction="column" spacing={1}>
                <MaterialTypography variant="caption" color="text">
                  Milestone Name<span style={{ color: "red" }}>*</span>
                </MaterialTypography>
                <MaterialInput
                  label="Milestone Name"
                  name="mileStoneName"
                  value={mileStoneData.mileStoneName}
                  onChange={handleMileStoneChange}
                  error={mileStoneData.mileStoneNameStatus === "error"}
                  success={mileStoneData.mileStoneNameStatus === "success"}
                  disabled={pages.view === true}
                />
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Stack direction="column" spacing={1}>
                <MaterialTypography variant="caption" color="text">
                  Milestone Description<span style={{ color: "red" }}>*</span>
                </MaterialTypography>
                <MaterialInput
                  label="Milestone Description"
                  name="mileStoneDescription"
                  multiline
                  rows={3}
                  value={mileStoneData.mileStoneDescription}
                  onChange={handleMileStoneChange}
                  error={mileStoneData.mileStoneDescriptionStatus === "error"}
                  success={
                    mileStoneData.mileStoneDescriptionStatus === "success"
                  }
                  disabled={pages.view === true}
                />
              </Stack>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Stack direction="column" spacing={1}>
                <MaterialTypography variant="caption" color="text">
                  Start Date<span style={{ color: "red" }}>*</span>
                </MaterialTypography>
                <MaterialDatePicker
                  label="Start Date"
                  name="startDate"
                  type="date"
                  value={mileStoneData.startDate}
                  onChange={handleStartDateChange}
                  error={mileStoneData.startDateStatus === "error"}
                  success={mileStoneData.startDateStatus === "success"}
                  disabled={pages.view === true}
                  options={{
                    minDate: selectedDate,
                    maxDate: selectedEndDate,
                    onDayCreate: (dObj, dStr, fp, dayElem) => {
                      const dayOfWeek = dayElem.dateObj.getDay();

                      if (selectedDate && selectedEndDate) {
                        const start = new Date(selectedDate).setHours(0, 0, 0, 0);
                        const end = new Date(selectedEndDate).setHours(0, 0, 0, 0);
                        const day = dayElem.dateObj.setHours(0, 0, 0, 0);

                        if (dayOfWeek === 0 || dayOfWeek === 6) {
                          dayElem.style.backgroundColor = "#EB5453";
                          dayElem.style.color = "#fff";
                          dayElem.style.borderRadius = "50%";
                        }

                        // ✅ Highlight full range in green
                        if (day >= start && day <= end) {
                          dayElem.style.backgroundColor = "#86C489";
                          dayElem.style.color = "#fff";
                          dayElem.style.borderRadius = "50%";
                          dayElem.style.fontWeight = "bold";
                        }

                        // ✅ Make weekends inside project range blue
                        if (dayOfWeek === 0 || dayOfWeek === 6) {
                          if (day >= start && day <= end) {
                            dayElem.style.backgroundColor = "#F3CBC9";
                            dayElem.style.color = "#fff";
                            dayElem.style.borderRadius = "50%";
                            dayElem.style.fontWeight = "bold";
                          }
                        }
                      } else {
                        // ✅ If no range selected, just mark weekends as red (outside project)
                        if (dayOfWeek === 0 || dayOfWeek === 6) {
                          dayElem.style.backgroundColor = "#EB5453";
                          dayElem.style.color = "#fff";
                          dayElem.style.borderRadius = "50%";
                        }
                      }
                    },
                  }}
                />

              </Stack>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Stack direction="column" spacing={1}>
                <MaterialTypography variant="caption" color="text">
                  End Date<span style={{ color: "red" }}>*</span>
                </MaterialTypography>
                <MaterialDatePicker
                  label="End Date"
                  name="endDate"
                  type="date"
                  value={mileStoneData.endDate}
                  onChange={handleEndDateChange}
                  error={mileStoneData.endDateStatus === "error"}
                  success={mileStoneData.endDateStatus === "success"}
                  disabled={pages.view === true}
                  options={{
                    minDate: mileStoneData?.startDate || selectedDate,
                    maxDate: selectedEndDate,
                    onDayCreate: (dObj, dStr, fp, dayElem) => {
                      const dayOfWeek = dayElem.dateObj.getDay();

                      if (selectedDate && selectedEndDate) {
                        const start = new Date(selectedDate).setHours(0, 0, 0, 0);
                        const end = new Date(selectedEndDate).setHours(0, 0, 0, 0);
                        const day = dayElem.dateObj.setHours(0, 0, 0, 0);

                        if (dayOfWeek === 0 || dayOfWeek === 6) {
                          dayElem.style.backgroundColor = "#EB5453";
                          dayElem.style.color = "#fff";
                          dayElem.style.borderRadius = "50%";
                        }

                        // ✅ Highlight full range in green
                        if (day >= start && day <= end) {
                          dayElem.style.backgroundColor = "#86C489";
                          dayElem.style.color = "#fff";
                          dayElem.style.borderRadius = "50%";
                          dayElem.style.fontWeight = "bold";
                        }

                        // ✅ Make weekends inside project range blue
                        if (dayOfWeek === 0 || dayOfWeek === 6) {
                          if (day >= start && day <= end) {
                            dayElem.style.backgroundColor = "#F3CBC9";
                            dayElem.style.color = "#fff";
                            dayElem.style.borderRadius = "50%";
                            dayElem.style.fontWeight = "bold";
                          }
                        }
                      } else {
                        // ✅ If no range selected, just mark weekends as red (outside project)
                        if (dayOfWeek === 0 || dayOfWeek === 6) {
                          dayElem.style.backgroundColor = "#EB5453";
                          dayElem.style.color = "#fff";
                          dayElem.style.borderRadius = "50%";
                        }
                      }
                    },
                  }}
                />

              </Stack>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <MaterialButton onClick={handleDialogClose} color="primary">
            Cancel
          </MaterialButton>
          {pages.view !== true && (
            <MaterialButton
              onClick={
                pages.edit === true
                  ? handleUpdateMileStone
                  : handleSubmitMileStone
              }
              color="dark"
              variant="contained"
              disabled={!checkAllFields()}
            >
              {pages.edit === true ? "Update" : "Save"}
            </MaterialButton>
          )}
        </DialogActions>
      </Dialog>
      <Dialog
        open={open}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this milestone?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            Cancel
          </Button>
          <MaterialButton onClick={handleConfirmDelete} color="red">
            Delete
          </MaterialButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
};

export default MileStone;
